import React from "react";
import { connect } from "react-redux";
import { Button } from "semantic-ui-react";
import "amcharts3/amcharts/amcharts";
import "amcharts3/amcharts/serial";
import "amcharts3/amcharts/themes/light";
import { removeAll } from "../../actions/graphListActions";
import ChartListItem from "./ChartListItem";

const ChartList = ({ graphsList, removeAll, goToRef }) => {
  const list = graphsList
    .map(chart => (
      <ChartListItem key={chart.code} chart={chart} goToRef={goToRef} />
    ))
    .reverse();
  return (
    <div>
      {graphsList.length > 0 ? (
        <div id="chartList">
          <div id="segment" style={styles.segment}>
            HISTOGRAMAS
          </div>
          <div align="right" style={{ paddingBottom: 10 }}>
            <Button color="blue" onClick={() => removeAll()}>
              Limpiar lista
            </Button>
          </div>
        </div>
      ) : null}
      {list}
    </div>
  );
};

const styles = {
  segment: {
    textAlign: "center",
    fontSize: "16px",
    color: "black",
    position: "relative",
    background: "#fff",
    margin: "1rem 0 1rem 0",
    padding: "1em 1em",
    borderRadius: "0.28571429rem",
    border: "2px solid #00ACC9",
    //backgroundColor: "#e05c5c",
    boxShadow: "0 1px 2px 0 rgba(34, 36, 38, 0.15)"
  }
};

function mapStateToProps(state) {
  return {
    graphsList: state.graphsList
  };
}

export default connect(
  mapStateToProps,
  { removeAll }
)(ChartList);
